import {LoginStore} from './login-store';
import {ClientsStore} from './clients-store';
import {UsersStore} from './users-store';
import {UserCarsStore} from './user-cars-store';
import {LeadStore} from './lead/lead-store';
import {CallStore} from './call/call-store';
import {SendSmsStore} from './sms/send-sms-store';
import {SmsListStore} from './sms/sms-list-store';
import {CrmStore} from './crm';

export function createStores() {
  return new class RootStore {
    constructor() {
      this.loginStore = new LoginStore(this);
      this.clientsStore = new ClientsStore(this);
      this.usersStore = new UsersStore(this);
      this.userCarsStore = new UserCarsStore(this);
      this.crmStore = new CrmStore(this);
      this.leadStore = new LeadStore(this);
      this.callStore = new CallStore(this);
      this.sendSmsStore = new SendSmsStore(this);
      this.smsListStore = new SmsListStore(this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/index.js